import { FC } from 'react';
import { TeamChatTypes } from '@frontend/api-team-chat';
import { getUserFullName } from '../../../utils';
import { MentionTag } from './mention-tag';

interface MentionRendererProps {
  currentUser?: TeamChatTypes.User;
  mentionUser: TeamChatTypes.User;
  highlightedText?: string;
}

/**
 * Renders a mention tag for the resolved mention user.
 */
export const MentionRenderer: FC<MentionRendererProps> = ({ currentUser, mentionUser, highlightedText }) => {
  const isSelf = mentionUser.userID === currentUser?.userID;

  return (
    <MentionTag
      label={`@${getUserFullName(mentionUser.firstName, mentionUser.lastName)}`}
      isSelf={isSelf}
      highlightedText={highlightedText}
      mentionUser={mentionUser}
    />
  );
};
